import { createAction, props } from '@ngrx/store';
import { ListUserDashboardDto, UserDashboardDto } from '../../../services/api.services';
import { AppError } from '../../../shared/utils';
import { DashboardsDashboard, DashboardsDisplayParams } from './reducer';

export const getDashboards = createAction(
  '[Dashboards] Get Dashboards'
);

export const getDashboardsSuccess = createAction(
  '[Dashboards] Get Dashboards Success',
  props<{ dashboards: DashboardsDashboard[] }>()
);

export const getDashboardsFailure = createAction(
  '[Dashboards] Get Dashboards Failure',
  props<{ error: AppError }>()
);


export const setSelectedDashboardId = createAction(
  '[Dashboards] Set Selected Dashboard Id',
  props<{ dashboardId: number }>()
);


export const addDashboard = createAction(
  '[Dashboards] Add Dashboard'
);

export const editDashboard = createAction(
  '[Dashboards] Edit Dashboard',
  props<{ dashboardId?: number }>()
);

export const viewDashboard = createAction(
  '[Dashboards] View Dashboard',
  props<{ dashboardId?: number }>()
);

export const addScheduleDashboard = createAction(
  '[Dashboards] Add Schedule Dashboard',
  props<{ dashboardId: number }>()
);

export const copyDashboard = createAction(
  '[Dashboards] Copy Dashboard',
  props<{ dashboardId?: number }>()
);

export const copyDashboardSuccess = createAction(
  '[Dashboards] Copy Dashboard Success',
  props<{ dashboard: ListUserDashboardDto }>()
);

export const copyDashboardFailure = createAction(
  '[Dashboards] Copy Dashboard Failure',
  props<{ error: AppError }>()
);


export const showDeleteDashboardDialog = createAction(
  '[Dashboards] Show Delete Dashboard Dialog',
  props<{ dashboardId?: number }>()
);

export const deleteDashboard = createAction(
  '[Dashboards] Delete Dashboard',
  props<{ dashboardId?: number }>()
);

export const deleteDashboardSuccess = createAction(
  '[Dashboards] Delete Dashboard Success',
  props<{ dashboardId: number }>()
);

export const deleteDashboardFailure = createAction(
  '[Dashboards] Delete Dashboard Failure',
  props<{ error: AppError }>()
);


export const shareDashboard = createAction(
  '[Dashboards] Share Dashboard',
  props<{ dashboardId?: number }>()
);

export const shareDashboardSuccess = createAction(
  '[Dashboards] Share Dashboard Success'
);

export const shareDashboardFailure = createAction(
  '[Dashboards] Share Dashboard Failure',
  props<{ error: AppError }>()
);


export const updateUserDashboard = createAction(
  '[Dashboards] Update User Dashboard',
  props<{ dashboard?:ListUserDashboardDto }>()
);

export const updateUserDashboardSuccess = createAction(
  '[Dashboards] Update User Dashboard Success',
  props<{ userDashboard: UserDashboardDto }>()
);

export const updateUserDashboardFailure = createAction(
  '[Dashboards] Update User Dashboard Failure',
  props<{ error: AppError }>()
);


export const toggleDashboardLibrary = createAction(
  '[Dashboards] Toggle Dashboard Library Inclusion',
  props<{ dashboard: ListUserDashboardDto }>()
);

export const toggleDashboardLibrarySuccess = createAction(
  '[Dashboards] Toggle Dashboard Library Inclusion Success',
  props<{ dashboardId: Number, fromLibrary: boolean }>()
);

export const toggleDashboardLibraryFailure = createAction(
  '[Dashboards] Toggle Dashboard Library Inclusion Failure',
  props<{ error: AppError }>()
);


export const updateDisplayParams = createAction(
  '[Dashboards] Update Display Params',
  props<{ displayParams: DashboardsDisplayParams }>()
);


export const toggleDashboardOnWelcomeScreen = createAction(
  '[Dashboards] Toggle Dashboard On Welcome Screen',
  props<{ dashboard: DashboardsDashboard }>()
);

export const toggleDashboardOnWelcomeScreenSuccess = createAction(
  '[Dashboards] Toggle Dashboard On Welcome Screen Success',
  props<{ dashboardId: number, onWelcomeScreen: boolean }>()
);

export const toggleDashboardOnWelcomeScreenFailure = createAction(
  '[Dashboards] Toggle Dashboard On Welcome Screen Failure',
  props<{ error: AppError }>()
);
